export default "__VITE_ASSET__CWUbs7DL__"